import React, { useState, Fragment } from "react";
import { nanoid } from "nanoid";
import data from "./mock-data.json";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";
import './Leaves.css';

const Leaves=()=>{
    const [contacts, setContacts] = useState(data);
  const [addFormData, setAddFormData] = useState({
   employee:"",
   leavetype:"",
   from:"",
   to:"",
   days:"",
   manager:""
    
  });
  const [editFormData, setEditFormData] = useState({
    employee:"",
   leavetype:"",
   from:"",
   to:"",
   days:"",
   manager:""
    
  });
  const [editContactId, setEditContactId] = useState(null);

  const handleAddFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    setAddFormData(newFormData);
  };
  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };
  const handleAddFormSubmit = (event) => {
    event.preventDefault();
    const newContact = {
        id: nanoid(),
        employee: addFormData.employee,
        leavetype: addFormData.leavetype,
        from: addFormData.from,
       to:addFormData.to,
       days:addFormData.days,
        reason:addFormData.reason,
        manager:addFormData.manager
       
      };
      const newContacts = [...contacts, newContact];
    
      setContacts(newContacts);
    };
    const handleEditFormSubmit = (event) => {
        event.preventDefault();
    
        const editedContact = {
          id: editContactId,
         employee: editFormData.employee,
        leavetype: editFormData.leavetype,
        from: editFormData.from,
       to:editFormData.to,
        days:editFormData.days,
        reason:editFormData.reason,
        manager:editFormData.manager
         
        };
    
        const newContacts = [...contacts];
    
        const index = contacts.findIndex((contact) => contact.id === editContactId);
    
        newContacts[index] = editedContact;
    
        setContacts(newContacts);
        setEditContactId(null);
      };
      const handleEditClick = (event, contact) => {
        event.preventDefault();
        setEditContactId(contact.id);
    
        const formValues = {
          employee: contact.employee,
          leavetype: contact.leavetype,
         from: contact.from,
          to:contact.to,
         days:contact.days,
         reason:contact.reason,
         manager:contact.manager
         
        };
    
        setEditFormData(formValues);
      };
    
      const handleCancelClick = () => {
        setEditContactId(null);
      };
      const handleDeleteClick = (contactId) => {
        const newContacts = [...contacts];
    
        const index = contacts.findIndex((contact) => contact.id === contactId);
    
        newContacts.splice(index, 1);
    
        setContacts(newContacts);
      };
    return(<div className="Leaves" id="Leaves">
        {/* <!-- Top Bar --> */}
    <div className="container-fluid1 py-2 icueTopBarContainer bg-white">
        <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="topBarLfContainer d-flex">
                    <div className="icueLogoContainer">
                        <img src="images/logo.png" alt="ICue Logo" className="icueLogo" />
                    </div>
                    <div className="icueSearchBox w-75 mx-3">
                        <div className="input-group ">
                            <span className="input-group-text" id="basic-addon1">
                                <i className="bi bi-search"></i>
                            </span>
                            <input type="search" id="text-search" className="form-control icueSearchBoxControl" placeholder="Enter keywords..." aria-label="Username" aria-describedby="basic-addon1"/>
                          </div>
                    </div>
                </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="d-flex flex-row-reverse">
                    <div className="icueProfile px-2">
                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                    </div>
                    <div className="position-relative px-2">
                        <a href="#" id="icueNotifyBoxHandler">
                            <i className="bi bi-bell">
                                <span className="position-absolute icueNofIndic"></span>
                            </i>
                        </a>
                        <div className="icueNotifyBox" id="icueNotifyBox">
                            Notifications
                        </div>
                    </div>

                    <div className="icueUserName fs-6 px-2">
                        Viral Patel
                    </div>

                    <div className="icueMail px-2">
                        <i className="bi bi-headset"></i> &nbsp;
                        adminhelpdesk@gmail.com
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- /Top Bar -->

    <!-- Main Body --> */}
    <div className="container-fluid my-2">
        <div className="row">
            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 bg-white">
                <div className="icueRespSideBar d-xxl-none d-xl-none d-lg-none d-md-block d-sm-block d-block" id="icueRespSideBar">
                    <button type="button" className="btn btn-primary" id="icueRespHumburger">
                        <i className="bi bi-grid-3x3-gap"></i>
                    </button>
                    <div className="icueSideBar" id="icueSideBar">
                        <nav className="navbar icueSideNavContainer">
                            <ul className="icueNavBarList">
                                <li className="icueNavBarItem ">
                                    <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                                </li>
                                <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">User Management</a>
                            </li>

                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem">
                                        {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                        <a href="#" className="icueSubNavLink  text-capitalize">Add Members</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/ListMembers" className="icueSubNavLink  text-capitalize">List of Members</a>
                                    </li>
                                </ul>
                            </li>
                            <hr></hr>

                                <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">Leave Management</a>
                            </li>

                            <li className="active">
                                <ul className="icueSubNavBar ">
                                    <li className="icueSubNavItem" style={{marginTop:"-8px", marginLeft:"-20px" }}>
                                       
                                        <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                    </li>                                   
                                </ul>                                
                            </li> 
                            <li>
                                <ul>
                                <li className="icueSubNavItem">
                                        <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                    </li>
                                </ul>
                                </li>             
                             <hr/>
                            <li className="icueNavBarItem border-bottom-1">
                                <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                            </li>                            
                            <li className="icueNavBarItem border-bottom-1">
                                <a href="/Attendance" className="icueNavBarLink" id="">Attendance</a>
                            </li>                       
    
                                 
    
                                <li className="icueNavBarItem">
                                    <a href="/Department" className="icueNavBarLink" id="">Department</a>
                                </li>
    
                                <li className="icueNavBarItem">
                                    <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                                </li>
                                
                                <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">Payroll</a>
                            </li>
                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem">
                                        <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                    </li>
                                </ul>
                                <hr></hr>
                            </li>
                                
                                <li className="icueNavBarItem border-bottom-0" style={{marginTop:"-18px"}}>
                                    <a href="#" className="icueNavBarLink" id="">Settings</a>
                                </li>
                                <li>
                                    <ul className="icueSubNavBar">
                                        <li className="icueSubNavItem">
                                            <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                        </li>
                                        <li className="icueSubNavItem">
                                            <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="icueNavSideBar d-xxl-block d-xl-block d-lg-block d-md-none d-sm-none d-none" id="icueNavSideBar">
                    <nav>
                        <ul className="icueNavBarList">
                            <li className="icueNavBarItem ">
                                <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                            </li>

                            <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">User Management</a>
                            </li>

                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem"  style={{marginTop:"-8px"}}>
                                        {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                        <a href="#" className="icueSubNavLink  text-capitalize">Add Member</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/ListMembers" className="icueSubNavLink  text-capitalize">List of Members</a>
                                    </li>
                                </ul>
                            </li>
                            <hr></hr>

                            <li className="icueNavBarItem border-bottom-0" style={{marginTop:"-18px"}}>
                                <a href="#" className="icueNavBarLink" id="" >Leave Management</a>
                            </li>

                            <li className="active">
                                <ul className="icueSubNavBar ">
                                    <li className="icueSubNavItem" style={{marginTop:"-8px", marginLeft:"-20px" }}>
                                       
                                        <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                    </li>                                   
                                </ul>                                
                            </li> 
                            
                            <li>
                                <ul>
                                <li className="icueSubNavItem">
                                        <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                    </li>
                                </ul>
                                </li>             
                             <hr/>
                            <li className="icueNavBarItem "style={{marginTop:"-18px"}}>
                                <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                            </li>   
                            <li className="icueNavBarItem ">
                                <a href="/Attendance" className="icueNavBarLink" id="">Attendance</a>
                            </li>   
                            
                            

                            
                            <li className="icueNavBarItem" >
                                <a href="/Department" className="icueNavBarLink" id="">Department</a>
                            </li>

                            <li className="icueNavBarItem">
                                <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                            </li>
                            

                            <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">Payroll</a>
                            </li>
                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem">
                                        <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                    </li>
                                </ul>
                                <hr></hr>
                            </li>
                           
                            <li className="icueNavBarItem border-bottom-0"  style={{marginTop:"-18px"}}>
                                <a href="#" className="icueNavBarLink" id="">Settings</a>
                            </li>
                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem">
                                        <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                    </li>
                                </ul>
                                <hr></hr>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 ">
                <main className="mainBodyContainer">
                    <div className="row my-2">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3">
                            <div className="d-flex justify-content-between">
                                <h4 className="text-captalize"style={{fontFamily:"ErasDemiITC", fontWeight:"bold", marginTop:"1rem", marginLeft:"12px"}}>Leaves</h4>
                                <div className="bg-transparent p-2  rounded-3">
                                <nav style={{bsbreadcrumbdivider: 'url(&#34;"data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="8" height="8"%3E%3Cpath d="M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z" fill="currentColor"/%3E%3C/svg%3E&#34")'}} aria-label="breadcrumb">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item bg-transparent" style={{fontFamily:"Calibri", fontSize:"bold"}}><a href="/Hrdashboard" className="text-decoration-none text-info">Dashboard</a></li>
                                        <li className="breadcrumb-item bg-transparent" style={{fontFamily:"Calibri"}}><a href="#" className="text-decoration-none text-info">Leave Management</a></li>
                                        <li className="breadcrumb-item text-muted text-capitalize bg-transparent" aria-current="page" style={{  fontSize:"bold"}}>Leaves</li>
                                    </ol>
                                </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row my-2">
                        <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 py-2 px-3">
                            <div className="bg-white p-1 shadow ">
                                <div className="row py-2">
                                    <div className="col-7">
                                        <div className="ps-2">
                                            <h3 className="fs-2 pt-1 icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"12px"}}>12/60</h3> 
                                            <h5 className="fs-6 mb-0 text-capitalize icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"10px"}}>today presents</h5>
                                        </div>
                                    </div>
                                    <div className="col-5 text-end">
                                        <div className="pe-2">
                                        <small><img src="images/today-presents-icon.svg " alt="today-presents" className="w-80 rounded-circle "/></small>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 py-2 px-3">
                            <div className="bg-white p-1 shadow ">
                                <div className="row py-2">
                                    <div className="col-7">
                                        <div className="ps-2">
                                            <h3 className="fs-2 pt-1 icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"12px"}}>8</h3>
                                            <h5 className="fs-6 mb-0 text-capitalize icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"10px"}}>planned leaves</h5>
                                        </div>
                                    </div>
                                    <div className="col-5 text-end">
                                        <div className="pe-2">
                                        <small><img src="images/planned-leaves-icon.svg " alt="planned-leaves" className="w-80 rounded-circle "/></small>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 py-2 px-3">
                            <div className="bg-white p-1 shadow ">
                                <div className="row py-2">
                                    <div className="col-8">
                                        <div className="ps-2">
                                            <h3 className="fs-2 pt-1 icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"12px"}}>0</h3>
                                            <h5 className="fs-6 mb-0 pb-0 text-capitalize icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"10px"}}>unplanned leaves</h5>
                                        </div>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="pe-2">
                                        <small><img src="images/unplanned-leaves-icon.svg " alt="unplanned-leaves" className="w-60 rounded-circle "/></small>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 py-2 px-3">
                            <div className="bg-white p-1 shadow ">
                                <div className="row py-2">
                                    <div className="col-8">
                                        <div className="ps-2">
                                            <h3 className="fs-2 pt-1 icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"12px"}}>12</h3>
                                            <h5 className="fs-6 mb-1 text-capitalize icueTextPrimary" style={{fontFamily:"ErasDemiITC", fontSize:"10px", lineHeight:"12px"}}>pending leave requests</h5>
                                        </div>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="pe-2">
                                        <small><img src="images/pending-leaves-icons.svg " alt="pending-leaves" className="w-60 rounded-circle "/></small>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    <div className="row my-2">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-1 px-3" >
                            <div className="bg-white p-2  rounded-3 shadow-sm">
                                <div className="px-2 py-3">                  
                                      <div className="container1">
                                      <div className="row">
                                             <div className=" col-xs-12 bg-white ">
                                                
                                             <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12">
               
                                             <div className="icueSearchBox w-75 mx-2" >
                                                  <div className="input-group " style={{ marginLeft:"-20px"}}>
                                                      
                                                 <input type="search" className="search form-control icueSearchBoxControl" placeholder="Search Users by Name, Email or Date" aria-label="Username" aria-describedby="basic-addon1" style={{backgroundColor:"#F4F7FC", marginTop:"-15px"}} />
                                                 <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12">
                                                    <a href="#" type="button" className="btn icueBgPrimary text-white pt-2  "  style={{fontFamily:"Calibri", color:"white", fontSize:"bold", height:"35px", lineHeight:"10px", marginTop:"-15px", width:"95px", marginLeft:"10px", textAlign:"center"}}>Search</a> 
                                                 </div>
                                                 
                                              </div>
                                                
                                              </div>
                                              </div>
                                              </div>
                                              </div>
                                             <br/>
                                               <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12  bg-white">
                                                    <div className="tab-content py-1 px-3 px-sm-0" id="myTabContent">
                                                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                                          <div className="row">              
                                                               <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12  bg-white">              
                                                               <form onSubmit={handleEditFormSubmit}>
                                            <table id="payrollTable" className="table table-hover table-striped results " width="102%" >
                                                <thead>
                                                    <tr className="text-uppercase" style={{lineHeight:"15px", fontFamily:"Calibri", fontStyle:"normal",  fontSize:"12px", backgroundColor:"#F4F7FC", textAlign:"center", marginTop:"-30px"}}>
                                                        <th className="py-3" >Employee</th>
                                                        <th  className="text-center py-3" >Leave Type</th>
                                                        <th  className="text-center py-3" >From</th>
                                                        <th  className="text-center py-3" >To</th>
                                                        <th  className="text-center py-3" >No. of Days</th>
                                                        <th  className="text-center py-3" >Reason</th>
                                                        <th  className="text-center py-3" >Manager</th>
                                                        <th  className="text-center py-3" >Leave Status</th>                                                        
                                                        <th  className="text-center py-3">Actions</th>
                                                                                                               
                                                    </tr>
                                                </thead>
                                                <tbody style={{lineHeight:"15px", fontFamily:"Calibri", fontSize:"16px"}}>
                                                    {/* <tr  style={{ border:"0"}}> */}
                                                   
                                                        {/* <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" /> &nbsp;
                                                            Shane Law <br></br><div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"38px", marginTop:"-10px"}}> Emp Code: 100001  </div></td>
                                                         <td className="text-center"> Medical Leave </td>
                                                        <td className="text-center">01-Jan-2021</td>
                                                        <td className="text-center">03-Jan-2021</td>
                                                        <td className="text-center">3 days</td>
                                                        <td className="text-center">Going to Hospital</td>
                                                        <td className="text-center">Jerry Helfer</td> 
                                                        <td >
                                                            <div className="selectWrapper">
                                                                
                                                                <select className="selectBox far">
                                                           <option value="far fa-scrubber" className="far"  >&#xf192; Declined </option>
                                                            <option  value="far fa-scrubber" className="" >&#xf192; New</option>
                                                            <option value="far fa-scrubber" className="">&#xf192; Pending</option>
                                                             <option value="far fa-scrubber" className="">&#xf192; Approved</option>                                                            
                                                        </select></div>  
                                                         
                                                         </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow ' style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                    <tr  style={{ border:"0", backgroundColor:"#F4F7FC"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                                                            Nicholas Motley<br/> <div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"40px", marginTop:"-10px"}}> Emp Code: 100002  </div></td>
                                                         <td className="text-center"> Hospitalization </td>
                                                        <td className="text-center">01-Feb-2021</td>
                                                        <td className="text-center">04-Feb-2021</td>
                                                        <td className="text-center">4 days</td>
                                                        <td className="text-center">Going to Hospital</td>
                                                        <td className="text-center">Iva Ryan</td>
                                                        <td >
                                                    
                                                        <div className="selectWrapper ">
                                                        <select className="selectBox far">
                                                           <option value="far fa-scrubber" className="far">&#xf192; New</option>
                                                            <option value="far fa-scrubber" className="far">&#xf192; Declined</option>
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                             <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>                                                            
                                                        </select></div>   
                                                            
                                                               </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow ' style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                    <tr  style={{ border:"0"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" /> &nbsp;
                                                            Drake Erickson<div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"38px", marginTop:"-10px"}}> Emp Code: 100003  </div></td>
                                                         <td className="text-center"> Maternity Leave </td>
                                                        <td className="text-center">01-Mar-2021</td>
                                                        <td className="text-center">02-Mar-2021</td>
                                                        <td className="text-center">2 days</td>
                                                        <td className="text-center">Injury</td>
                                                        <td className="text-center">Kurt Bates</td> 
                                                        <td >
                                                            <div className="selectWrapper ">
                                                        <select className="selectBox far">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                           <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>
                                                            <option  value="far fa-scrubber" className="far">&#xf192; New</option>                                                           
                                                             <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>                                                            
                                                        </select></div>    </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                    <tr  style={{ border:"0", backgroundColor:"#F4F7FC"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" /> &nbsp;
                                                            Wally Mann <div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"40px", marginTop:"-10px"}}> Emp Code: 100004  </div></td>
                                                         <td className="text-center"> Casual Leave </td>
                                                        <td className="text-center">01-Apr-2021</td>
                                                        <td className="text-center">10-Apr-2021</td>
                                                        <td className="text-center">10 days</td>
                                                        <td className="text-center">Vaccation</td>
                                                        <td className="text-center">David Elson</td>
                                                        <td >
                                                    
                                                        <div className="selectWrapper ">
                                                        <select className="selectBox far">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>
                                                           <option  value="far fa-scrubber" className="far">&#xf192; New</option>
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                                                                                        
                                                        </select></div>   
                                                            
                                                               </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                    <tr  style={{ border:"0"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" /> 
                                                           Howard Savage<div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"38px", marginTop:"-10px"}}> Emp Code: 100005  </div></td>
                                                         <td className="text-center"> Casual Leave </td>
                                                        <td className="text-center">01-May-2021</td>
                                                        <td className="text-center">08-May-2021</td>
                                                        <td className="text-center">8 days</td>
                                                        <td className="text-center">Pets emergencies</td>
                                                        <td className="text-center">Lorri Warf</td> 
                                                        <td >
                                                            <div className="selectWrapper ">
                                                        <select className="selectBox far ">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; New</option>
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                           <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>                                                            
                                                             <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>                                                            
                                                        </select></div>    </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                    <tr  style={{ border:"0", backgroundColor:"#F4F7FC"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" /> &nbsp;
                                                            Ford Becker <div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"40px", marginTop:"-10px"}}> Emp Code: 100006  </div></td>
                                                         <td className="text-center"> Paternity Leave </td>
                                                        <td className="text-center">01-Jun-2021</td>
                                                        <td className="text-center">05-Jun-2021</td>
                                                        <td className="text-center">5 days</td>
                                                        <td className="text-center">Deaths and Funerals</td>
                                                        <td className="text-center">Paula Mora</td>
                                                        <td >
                                                    
                                                        <div className="selectWrapper ">
                                                        <select className="selectBox far">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; New</option>
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>                                                          
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>
                                                            <option  value="far fa-scrubber" className="far">&#xf192;Pending</option>
                                                                                                                        
                                                        </select></div>   
                                                            
                                                               </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                     <tr  style={{ border:"0"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" /> &nbsp;
                                                           Byron  <br/><div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"38px", marginTop:"-10px"}}> Emp Code: 100007  </div></td>
                                                         <td className="text-center"> Casual Leave </td>
                                                        <td className="text-center">01-Jul-2021</td>
                                                        <td className="text-center">03-Jul-2021</td>
                                                        <td className="text-center">3 days</td>
                                                        <td className="text-center">Tragedy at home</td>
                                                        <td className="text-center">John Dukes</td> 
                                                        <td >
                                                            <div className="selectWrapper ">
                                                        <select className="selectBox far">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; New</option>
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                           <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>                                                                                   
                                                             <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>                                                            
                                                        </select></div>    </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                          
                                                    </tr> 
                                                    <tr  style={{ border:"0", backgroundColor:"#F4F7FC"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" /> &nbsp;
                                                           Shane Law <div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"40px", marginTop:"-10px"}}> Emp Code: 100008  </div></td>
                                                         <td className="text-center"> Loss of Pay </td>
                                                        <td className="text-center">01-Jan-2021</td>
                                                        <td className="text-center">03-Jan-2021</td>
                                                        <td className="text-center">3 days</td>
                                                        <td className="text-center">Personal reasons</td>
                                                        <td className="text-center">Kathy Pacheco</td>
                                                        <td >
                                                    
                                                        <div className="selectWrapper ">
                                                        <select className="selectBox far">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>
                                                        <option  value="far fa-scrubber" className="far">&#xf192; New</option>                                                                
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                                                                                        
                                                        </select></div>   
                                                            
                                                               </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr> 
                                                    <tr  style={{ border:"0"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                                                           Nicholas Motley <br/><div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"38px", marginTop:"-10px"}}> Emp Code: 100009  </div></td>
                                                         <td className="text-center"> Casual Leave </td>
                                                        <td className="text-center">01-Feb-2021</td>
                                                        <td className="text-center">05-Feb-2021</td>
                                                        <td className="text-center">5 days</td>
                                                        <td className="text-center">Personal reasons</td>
                                                        <td className="text-center">James Hall</td> 
                                                        <td >
                                                            <div className="selectWrapper ">
                                                        <select className="selectBox far ">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Approved</option> 
                                                        <option  value="far fa-scrubber" className="far">&#xf192; New</option>
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                           <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>                                                                                                                      
                                                                                                                       
                                                        </select></div>    </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                          
                                                    </tr> 
                                                    <tr  style={{ border:"0", backgroundColor:"#F4F7FC"}}>
                                                        <td >
                                                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                                                          Dracke Erickson <div style={{fontSize:"12px", color:" #7D90B2", marginLeft:"40px", marginTop:"-10px"}}> Emp Code: 100010  </div></td>
                                                         <td className="text-center">Casual Leave </td>
                                                        <td className="text-center">01-Mar-2021</td>
                                                        <td className="text-center">01-Mar-2021</td>
                                                        <td className="text-center">1 days</td>
                                                        <td className="text-center">For unforeseen reaons</td>
                                                        <td className="text-center">Cornico McCOy</td>
                                                        <td >
                                                    
                                                        <div className="selectWrapper ">
                                                        <select className="selectBox far">
                                                        <option  value="far fa-scrubber" className="far">&#xf192; Approved</option>
                                                        <option  value="far fa-scrubber" className="far">&#xf192; New</option>                                                                                                                  
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Declined</option>
                                                            <option  value="far fa-scrubber" className="far">&#xf192; Pending</option>
                                                                                                                        
                                                        </select></div>   
                                                            
                                                               </td>                                                       
                                                        
                                                        <td className="text-center  py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>  */}
                                                    

{contacts.map((contact) => (
              <Fragment>
                  
                {editContactId === contact.id ? (
                  <EditableRow
                    editFormData={editFormData}
                    handleEditFormChange={handleEditFormChange}
                    handleCancelClick={handleCancelClick}
                  />
                ) : (
                  <ReadOnlyRow
                    contact={contact}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                  />
                )}
              </Fragment>
              
            ))}
            
                                                  
                                                   
                                                </tbody>
                                            </table>
                                            </form>
                                        </div>
                                    </div>   
                                     
                                   </div>
                                   

</div>
</div>
</div>
</div>

       
    </div>
</div>
</div>
</main>
</div>
        </div>
    </div>
</div>
    )}
    export default Leaves;